import { Color } from '@billy/design-system'

import { EInvoiceStatus } from '../enums/eInvoiceStatus'
import type { EInvoiceStatusConfig } from '../types/eInvoiceStatusConfig'

export const eInvoiceStatusToConfig: Record<EInvoiceStatus, EInvoiceStatusConfig> = {
  [EInvoiceStatus.Approved]: {
    icon: 'check',
    labelTKey: 'external_invoices.view.sidebar.einvoice_details_card.status.approved.label',
    shortDescriptionTKey: 'external_invoices.view.sidebar.einvoice_details_card.status.approved.short_description',
    tagColor: 'neutral',
  },
  [EInvoiceStatus.Completed]: {
    labelTKey: 'external_invoices.view.sidebar.einvoice_details_card.status.complete.label',
    shortDescriptionTKey: null,
    tagColor: 'neutral',
  },
  [EInvoiceStatus.Disputed]: {
    detailedDescriptionTKey:
      'external_invoices.view.sidebar.einvoice_details_card.status.disputed.detailed_description',
    icon: 'triangleAlert',
    labelTKey: 'external_invoices.view.sidebar.einvoice_details_card.status.disputed.label',
    shortDescriptionTKey: 'external_invoices.view.sidebar.einvoice_details_card.status.disputed.short_description',
    tagColor: 'orange',
  },
  [EInvoiceStatus.Failed]: {
    icon: 'circleAlert',
    labelTKey: 'external_invoices.view.sidebar.einvoice_details_card.status.failed.label',
    shortDescriptionTKey: 'external_invoices.view.sidebar.einvoice_details_card.status.failed.short_description',
    shouldShowContactSupport: true,
    shouldShowReasonCode: false,
    tagColor: 'red',
  },
  [EInvoiceStatus.NotIssuedByPlatform]: {
    icon: 'circleAlert',
    labelTKey: 'external_invoices.view.sidebar.einvoice_details_card.sent.label',
    shortDescriptionTKey:
      'external_invoices.view.sidebar.einvoice_details_card.status.not_issued_by_platform.short_description',
    shouldShowReasonCode: false,
    tagColor: 'yellow',
  },
  [EInvoiceStatus.Paid]: {
    icon: 'check',
    labelTKey: 'external_invoices.view.sidebar.einvoice_details_card.status.paid.label',
    shortDescriptionTKey: 'external_invoices.view.sidebar.einvoice_details_card.status.paid.short_description',
    tagColor: 'neutral',
  },
  [EInvoiceStatus.PartiallyApproved]: {
    detailedDescriptionTKey:
      'external_invoices.view.sidebar.einvoice_details_card.status.partially_approved.detailed_description',
    labelTKey: 'external_invoices.view.sidebar.einvoice_details_card.status.partially_approved.label',
    shortDescriptionTKey:
      'external_invoices.view.sidebar.einvoice_details_card.status.partially_approved.short_description',
    tagColor: 'yellow',
  },
  [EInvoiceStatus.PaymentSent]: {
    icon: 'banknoteArrowUp',
    labelTKey: 'external_invoices.view.sidebar.einvoice_details_card.status.payment_sent.label',
    shortDescriptionTKey: 'external_invoices.view.sidebar.einvoice_details_card.status.payment_sent.short_description',
    tagColor: 'neutral',
  },
  [EInvoiceStatus.Refused]: {
    detailedDescriptionTKey: 'external_invoices.view.sidebar.einvoice_details_card.status.refused.detailed_description',
    icon: 'ban',
    labelTKey: 'external_invoices.view.sidebar.einvoice_details_card.status.refused.label',
    shortDescriptionTKey: 'external_invoices.view.sidebar.einvoice_details_card.status.refused.short_description',
    tagColor: 'red',
  },
  [EInvoiceStatus.Rejected]: {
    detailedDescriptionTKey:
      'external_invoices.view.sidebar.einvoice_details_card.status.rejected.detailed_description',
    icon: 'circleAlert',
    labelTKey: 'external_invoices.view.sidebar.einvoice_details_card.status.rejected.label',
    shortDescriptionTKey: 'external_invoices.view.sidebar.einvoice_details_card.status.rejected.short_description',
    tagColor: 'red',
  },
  [EInvoiceStatus.Sent]: {
    icon: 'paperPlane',
    labelTKey: 'external_invoices.view.sidebar.einvoice_details_card.sent.label',
    shortDescriptionTKey: null,
    tagColor: 'neutral',
  },
  [EInvoiceStatus.Submitted]: {
    icon: 'check',
    labelTKey: 'external_invoices.view.sidebar.einvoice_details_card.status.submitted.label',
    shortDescriptionTKey: 'external_invoices.view.sidebar.einvoice_details_card.status.submitted.short_description',
    tagColor: 'neutral',
  },
  [EInvoiceStatus.Suspended]: {
    detailedDescriptionTKey:
      'external_invoices.view.sidebar.einvoice_details_card.status.suspended.detailed_description',
    icon: 'clockAlert',
    labelTKey: 'external_invoices.view.sidebar.einvoice_details_card.status.suspended.label',
    shortDescriptionColor: Color.Orange700,
    shortDescriptionTKey: 'external_invoices.view.sidebar.einvoice_details_card.status.suspended.short_description',
    tagColor: 'orange',
  },
}
